/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Header_Plan_FreeInputs */

const en_header_plan_free = /** @type {(inputs: Header_Plan_FreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Free`)
};

const id_header_plan_free = /** @type {(inputs: Header_Plan_FreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Free`)
};

/**
* | output |
* | --- |
* | "Free" |
*
* @param {Header_Plan_FreeInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const header_plan_free = /** @type {((inputs?: Header_Plan_FreeInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Header_Plan_FreeInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_header_plan_free(inputs)
	return en_header_plan_free(inputs)
});